import React, { Component } from "react"
import { Link } from 'react-router-dom'
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from 'lodash'

class BuilderList extends Component {

	constructor(props) {
		super(props)
	}

	renderBuilders = () => {
		var sorted = []
		_.forEach(this.props.payload.public.builders.children, v => {
			sorted.push({id: v.id, name: v.name})
		})
		sorted = _.sortBy(sorted, ['name'])
		return _.map(sorted, (v, k) => {
			return <li className="builders__item" key={k}><Link to={`/builders/${v.id}`}>{v.name}</Link></li>
		})
	}

	render() {
		
		if(this.props.payloadStatus){
			return (
				<div className="builders">
					<Title title="Builders" />
					<div className="content">
						<ul className="builders__list">
						{this.renderBuilders()}
						</ul>
					</div>
				</div>
			)
		}
		else {
			return('')
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(BuilderList)
